import { render, staticRenderFns } from "./GameItem.vue?vue&type=template&id=712584c9&scoped=true&"
import script from "./GameItem.vue?vue&type=script&lang=js&"
export * from "./GameItem.vue?vue&type=script&lang=js&"
import style0 from "./GameItem.vue?vue&type=style&index=0&id=712584c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712584c9",
  null
  
)

export default component.exports